import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const TRIGGER_CLASS_NAME = tv({
  base: clsx(
    "w-full max-w-[800px] data-[placeholder]:text-ui-300 flex h-[35px] items-center justify-between gap-[5px] rounded border border-ui-200 leading-6 outline-none group bg-ui-white [&_span]:first:truncate [&_span]:first:max-w-[90%]",
    // disabled
    "disabled:bg-ui-100 disabled:cursor-not-allowed disabled:text-base-disabled",
  ),
  variants: {
    error: {
      true: "border-functional-danger hover:bg-functional-danger-light",
      // 上書き防止の為hover,focusはこちらに記述
      false:
        "hover:enabled:border-ui-300 focus:enabled:border-2 focus:enabled:border-ui-400 data-[state=open]:enabled:border-ui-400 data-[state=open]:enabled:border-2",
    },
    size: {
      sm: "h-[32px] text-ui14 pl-3 pr-2",
      md: "h-[40px] text-ui16 px-[15px]",
      lg: "h-[50px] text-ui16 px-[15px]",
    },
    dangerTextColor: {
      true: "text-functional-danger",
      false: "text-ui-500",
    },
  },
  defaultVariants: {
    error: false,
  },
});

export const ITEMS_TO_SHOW = 6.75;
export const SELECT_ITEM_HEIGHT = 44;
